import type * as React from 'react';

import type { Space } from '@gitbook/api-client';
import type * as analytics from '@gitbook/app-analytics/client';
import type * as hiveCore from '@gitbook/hive-core';
import { PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';

import type { PageToCItemProps } from '../TableOfContents';
import { withPageCommands } from './withPageCommands';

export interface PageToolbarProps {
    space: Space;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
    page: hiveCore.RevisionPage;
    readOnly: boolean;
    adaptiveContentContext: PageToCItemProps['adaptiveContentContext'];
    className?: string;
}

/**
 * Toolbar displayed in a page header as a vertical ellipsis.
 */
export const PageToolbar = withPageCommands<PageToolbarProps>(
    function PageToolbarImpl(props): React.ReactElement {
        const { commandsElement, commandsPalette, className } = props;

        return (
            <>
                {commandsElement}
                <PaletteButton
                    palette={commandsPalette}
                    leadingIcon={Icon.MoreVertical}
                    iconOnly
                    kind="blank"
                    size="large"
                    label="Page actions"
                    testID="pageToolbar.paletteButton"
                    className={className}
                />
            </>
        );
    }
);
